export const MB = 1048576;
export const UPLOAD_TOTAL_FILES_COUNT_LIMIT = 10;
export const UPLOAD_ONE_FILE_SIZE_LIMIT: number = 64 * MB;
export const UPLOAD_ALLOWED_EXTENSIONS: string[] = [
  '.png',
  '.bmp',
  '.gif',
  '.jpg',
  '.jpeg',
  '.tif',
  '.tiff',
  '.pdf',
];

export const COOKIE_EXCEPTION_LIST: RegExp[] = [
  RegExp('FEDERATED_LOGIN'),
  RegExp('oo_click'),
  RegExp('oo_inv_*'),
  RegExp('user_csid'),
  RegExp('user_cuid'),
  RegExp('ac.uuid'),
  RegExp('browserFingerprint'),
  RegExp('user_dn'),
  RegExp('___tk*'),
  RegExp('TLTUID'),
  RegExp('TLTSID'),
  RegExp('CHCP_DEEPLINK'),
  RegExp('tr.uuid'),
  RegExp('PD_STATEFUL_*'),
  RegExp('AMWEBJCT*'),
  RegExp('DCX*'),
  RegExp('voc_*'),
];

export const DEEPLINK_BLACKLIST: string[] = [
  '/app',
  '/app/',
  '/app/login',
  '/app/common.js',
  '/app/assets/images/isam-keepalive.gif',
  '/app/auth_callback.html',
];

export const mockTok =
  'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjRpeWVFSUZnTkcwQkRoSGdZbzR3eSJ9.eyJjaWduYS5hdXRoX3RpbWUiOjE3NTkzMzE3NDUsImNpZ25hLmNuIjoiYzM2MG1lZDAxIiwiY2lnbmEuZW5jcnlwdGVkQ24iOiJTU0hlNVVjbFFINDVNNDZKaUFjLzd2R3hkSmpPVE44dzJ0WEJkMUNNcGhaN0JSK3l3QmZ3M21tM3VhZzhDRW9RNHJJZTcwK3VxV2UyeWZ1NVFiUUw1OTR2Y2dWMmQwcXdodG5RS2IvaW5IQThsK2FDVDNGZ2I4cE1KdFVNY21WcEYyN3BWM05NUFVnT2gwZ0R0NjhWTGFweEdDOXVuZ0U1TjQwOHVkUHhab2M9IiwiY2lnbmEuZW50aXRsZW1lbnRzIjpbIkRpcmVjdG9yeVVwZGF0ZXMiLCJFbnJvbGxBbmRNYW5hZ2VFRlQiLCJFT0NBY3Rpb25hYmxlUmVwb3J0aW5nIiwiRGVsZWdhdGlvbkFjY2Vzc0FuZFZpZXdzIiwiQ2xhaW1zU2VhcmNoLVJlY29uc2lkZXJhdGlvbiIsIlByZWNlcnRpZmljYXRpb24iLCJQYXRpZW50UmV2aWV3c1ZpZXciLCJDbGFpbXNTZWFyY2gtQ2xhaW1Db3JyZXNwb25kZW5jZSIsIlJlbWl0dGFuY2VSZXBvcnRzIiwiQ2xhaW1zU2VhcmNoIiwiUGF0aWVudFNlYXJjaCIsIkNsYWltc1NlYXJjaC1DbGFpbVN0YXR1c05vdGlmaWNhdGlvbnMiLCJCYXNpY0luZm9ybWF0aW9uIl0sImNpZ25hLmp0aSI6IjdmOTViN2YzLTc2NjgtNDUxMC1iYmQzLTFkYWRmNjNmNTgwZCIsImNpZ25hLmxvYiI6Ik1FREJIIiwiY2lnbmEucGVybWlzc2lvblRvZ2dsZXMiOlsibWVzc2FnZUNlbnRlckNsYWltU3RhdHVzIiwibWVzc2FnZUNlbnRlckRhc2hib2FyZCIsImNsYWltMzYwIiwiY2hhdCIsInBlbmRDbGFpbUVuaCIsInNlY3F1ZXN0dXBkIl0sImNpZCI6ImNTTkZBRUhQbXM1U2p4bUpQUVN4aE12bTJDRGlobWZHIiwiY2lnbmEucm9vdCI6InRydWUiLCJjaWduYS51aWQiOiJhdXRoMHw2ODUzODE4ODUwNzA0OGQ4MjY1Y2Q2YzkiLCJlbnQuYXBwTmFtZSI6IkNIQ1Atd2ViIiwiZW50LmRvbWFpbiI6ImNpZ25hLWNoY3AtcHJvdmlkZXIiLCJlbnQuZW52Ijoic2l0IiwiZW50LnRva2VuVHlwZSI6InVzZXItZXh0IiwiZW50LnZlciI6MSwidWwubG9iRG9tYWluIjoicHJvdmlkZXJzLXNpdCIsInVsLmxvYlN1YiI6ImFwYXJuYS5rYWx5YW5pQGV2ZXJub3J0aC5jb20iLCJ1bC5zdWIiOiJhcGFybmEua2FseWFuaUBldmVybm9ydGguY29tIiwiY2lnbmEucGFzc3dvcmRFeHBpcnkiOjUxLCJpc3MiOiJodHRwczovL3QudW5pdmVyc2FsLWxvZ2luLmNpZ25hLmNvbS8iLCJzdWIiOiJhdXRoMHw2ODUzODE4ODUwNzA0OGQ4MjY1Y2Q2YzkiLCJhdWQiOlsiaHR0cHM6Ly9hLWNoY3AudGVzdC5kaWdpdGFsZWRnZS5jaWduYS5jb20iLCJodHRwczovL3VuaXZlcnNhbC1jaWduYS10ZXN0LmFhMi1kZXYuYXV0aDAuY29tL3VzZXJpbmZvIl0sImlhdCI6MTc1OTMzMTc0NiwiZXhwIjoxNzU5MzMyMzQ2LCJzY29wZSI6Im9wZW5pZCBwcm9maWxlIGVtYWlsIiwiYXpwIjoiY1NORkFFSFBtczVTanhtSlBRU3hoTXZtMkNEaWhtZkcifQ.FWJ8gbqQAkpH_FjI48b8neSC-lk7qLu1cFQMrKeDOjoLMddaNW_WV2drbrhAVge_mu6nqtySSJdBBEwv5meHESl2mUxoLkweGXa-_NIUEVl9EbV-JzCxd7SjCiAXAY_tOAuGyWqsrMgBZ-Z5QrHJ8hfUbTz23c8df9tR9QjANMpJChfNw-dTu0wvQ2GQ3PBaaVpMnIraiALt3-xpfZuuhcpsigH708Tl8iYHfn6q9FumY7suqcjdxXTK-8_o3ZmP0uI9l2OUWxa8plFhCWM2dl3UxDaKul1tj7MaYROz1aGxXcZT-aTOeF23HpsxTOBBA9Fie-Hpw_WE8IgLj5Gzpw';
